import { isCryptoKey } from './webcrypto.js';
export default (key) => {
    return isCryptoKey(key);
};
export const types = ['CryptoKey'];



// WEBPACK FOOTER //
// ./~/jose/dist/browser/runtime/is_key_like.js